import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { childrenType } from '../../../constants/proptype-validation';
import { Label } from '@adsk/bim360-matrix-react-components';
import IssueInfoPopover from '../../IssueInfoPopover';
import cx from 'classnames';

/**
 * @class
 */
class FormLabel extends Component {

  /**
   * render
   */
  render() {
    const { children, isFieldMandatory, infoPopoverText, container } = this.props;

    const labelClassName = cx('FormLabel__Label', {
      'FormLabel__Label--required': isFieldMandatory,
    });

    return (
      <div className="FormLabel" data-testid="FormLabel">
        <Label className={labelClassName}>
          {children}
        </Label>
        {infoPopoverText && <IssueInfoPopover message={infoPopoverText} container={container} />}
      </div>
    );
  }
}

FormLabel.displayName = 'FormLabel';

FormLabel.propTypes = {
  children: childrenType.isRequired,
  isFieldMandatory: PropTypes.bool.isRequired,
  infoPopoverText: PropTypes.string,
  container: PropTypes.object,
};

export default FormLabel;
